module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAPCAAAAACg65LLAAAAEklEQVQY02P8z4AfMI4qGEYKAGvfDwF0TxpLAAAAAElFTkSuQmCC"